import { AppDrawer } from "@/components/layout/elements/AppDrawer";
import { AppHeader } from "@/components/layout/elements/AppHeader";
import { useMeAutoRefresh } from "@/features/auth/hooks/useMeAutoRefresh";
import { useProductHandoffSync } from "@/features/mint-oauth-redirect/hooks/useProductHandoffSync";
import { withAuth } from "@/hoc/withAuth";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useVisible } from "@/hooks/useVisible";
import { FCC } from "@/types/common";
import { Box, Stack, styled } from "@mui/material";
import { Outlet } from "react-router-dom";

export const AdminLayout: FCC = ({ children }) => {
  const showDrawer = useVisible();
  const { isLaptop } = useMediaQuery();

  // Keep the current user fresh: poll /get-me while active, pause on idle, refetch on return.
  useMeAutoRefresh();

  // The product tab mints the SSO redirect (and provisions the account) on its own; pick up the result here.
  useProductHandoffSync();

  return (
    <>
      <AppHeader isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />
      <AppDrawer isOpenDrawer={showDrawer.visible} toggleDrawer={showDrawer.toggle} />
      <Stack width="100%" direction="row">
        <Stack height="100vh" />
        <ChildrenWrapper isLaptop={isLaptop} onClick={showDrawer.close}>
          <Stack maxWidth="1200px" margin="0 auto" height="100%">
            <Outlet />
            {children}
          </Stack>
        </ChildrenWrapper>
      </Stack>
    </>
  );
};

export const AdminLayoutWithAuth = withAuth(AdminLayout);

const ChildrenWrapper = styled(Box)<{ isLaptop: boolean }>`
  padding: 24px;
  margin-left: ${({ isLaptop }) => (isLaptop ? "0" : "242px")};
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  margin-top: 56px;
`;
